import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  padding-block: 12px;
  padding-inline: 12px;
  border-block-end: 1px solid #d7d7d7;
`;

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StartTime = styled.div`
  color: #000000;
  font-size: 13px;
  line-height: 15.23px;

  opacity: 0.7;
`;

export const SportDetails = styled.div`
  opacity: 0.7;
`;

export const Sport = styled.div`
  margin-block-end: 4px;

  color: #000000;
  font-weight: 700;
  font-size: 15px;
  line-height: 17.58px;
`;

export const Description = styled.div`
  color: #333333;
  font-size: 13px;
  line-height: 15.23px;
`;

export const Athlete = styled.div`
  color: #333333;
  font-size: 13px;
  line-height: 15.23px;
`;
